import React, { useState } from 'react';
import {
  Typography,
  TextField,
  Button,
  CircularProgress,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from '@mui/material';
import { Send } from '@mui/icons-material';
import QRCode from 'qrcode';

interface WiFiToQRProps {
  onQRGenerated: (imageUrl: string) => void;
}

const WiFiToQR: React.FC<WiFiToQRProps> = ({ onQRGenerated }) => {
  const [wifiData, setWifiData] = useState({
    networkName: '',
    authType: 'WPA',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      
      // Format WiFi data according to WIFI:T:WPA;S:networkName;P:password;;
      const wifiString = `WIFI:T:${wifiData.authType};S:${wifiData.networkName};P:${wifiData.password};;`;
      
      // Generate QR code as data URL
      const qrDataUrl = await QRCode.toDataURL(wifiString, {
        errorCorrectionLevel: 'H',
        margin: 1,
        width: 300,
        color: {
          dark: '#000000',
          light: '#ffffff'
        }
      });
      
      onQRGenerated(qrDataUrl);
    } catch (error) {
      console.error('Error generating WiFi QR code:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Typography variant="h4" gutterBottom>
        Generador de Código QR para WiFi
      </Typography>

      <FormControl fullWidth sx={{ mb: 2 }}>
        <TextField
          label="Nombre de la Red"
          value={wifiData.networkName}
          onChange={(e) => setWifiData({ ...wifiData, networkName: e.target.value })}
          required
        />
      </FormControl>

      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Tipo de Autenticación</InputLabel>
        <Select
          value={wifiData.authType}
          label="Tipo de Autenticación"
          onChange={(e) => setWifiData({ ...wifiData, authType: e.target.value })}
        >
          <MenuItem value="WPA">WPA</MenuItem>
          <MenuItem value="WEP">WEP</MenuItem>
        </Select>
      </FormControl>

      <FormControl fullWidth sx={{ mb: 2 }}>
        <TextField
          label="Contraseña"
          type="password"
          value={wifiData.password}
          onChange={(e) => setWifiData({ ...wifiData, password: e.target.value })}
          required
        />
      </FormControl>

      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={handleSubmit}
        disabled={loading || !wifiData.networkName || !wifiData.password}
        startIcon={loading ? <CircularProgress size={20} /> : <Send />}
        fullWidth
      >
        {loading ? 'Generando...' : 'Generar QR'}
      </Button>
    </>
  );
};

export default WiFiToQR; 